import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccess = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	fill: "none",
	stroke: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.99967 15C11.6816 15 14.6663 12.0153 14.6663 8.33335C14.6663 4.65146 11.6816 1.66669 7.99967 1.66669C4.31778 1.66669 1.33301 4.65146 1.33301 8.33335C1.33301 12.0153 4.31778 15 7.99967 15Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6 8.33327L7.33333 9.66661L10 6.99994",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgSuccess;
